

import API from "../api/api";


import api from "../utils/axios";

export const sendOtp = async (mobile) => {
    try {
        const response = await api.post(
            "/auth/send-otp",
            { mobile }
        );

        return {
            success: response.data?.success ?? true,
            message: response.data?.message || "",
            remaining_seconds: Number(
                response.data?.remaining_seconds || 0
            ),
        };

    } catch (error) {

        const data = error.response?.data || {};

        console.log("OTP API ERROR DATA:", data);

        return {
            success: false,
            message:
                data.message ||
                "ارسال کد تایید با خطا مواجه شد.",

            remaining_seconds: Number(
                data.remaining_seconds || 0
            ),
        };
    }
};
export const verifyOtp = async (mobile, otp) => {
    const response = await api.post("/auth/verify-otp", {
        mobile,
        otp,
    });

    return response.data;
};


export const loginWithPassword = async (mobile, password) => {
    const response = await api.post("/auth/login-password", {
        mobile,
        password,
    });

    return response.data;
};


export const getCurrentUser = async () => {
    const response = await api.get("/auth/me");

    return response.data;
};


export const logoutUser = async () => {
    const response = await api.post("/auth/logout");

    return response.data;
};







export async function loginUser(mobile, password) {

  
   console.log("mobile:",mobile);
  const response = await fetch(`http://127.0.0.1:8000/api/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      mobile,
      password,
    }),
  });

  const users = await response.json();
  console.log(users);

   return users;
}



export const sendPasswordRecoveryOtp = async (mobile) => {
    const response = await api.post(
        "/auth/password-recovery/send-otp",
        {
            mobile,
        }
    );

    return response.data;
};


export const resetPassword = async (
    mobile,
    otp,
    password,
    password_confirmation
) => {
    const response = await api.post(
        "/auth/password-recovery/reset",
        {
            mobile,
            otp,
            password,
            password_confirmation,
        }
    );

    return response.data;
};



// export async function loginUser(mobile, password) {

//     const { data } = await axios.post("http://127.0.0.1:8000/api/login", {
//         mobile,
//         password,
//     });

//     return data;
// }



// REGISTER
export async function registerUser(userData) {
  // GET USERS
  const response = await fetch(`${API}/users`);

  const users = await response.json();

  const exists = users.find((u) => u.email === userData.email);

  if (exists) {
    throw new Error("Email already exists");
  }

  // POST USER
  const save = await fetch(`${API}/users`, {
    method: "POST",

    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(userData),
  });

  return save.json();
}

export async function updateProfile(id, data) {
  const response = await fetch(`${API}/users/${id}`, {
    method: "PUT",

    headers: {
      "Content-Type": "application/json",
    },

    body: JSON.stringify(data),
  });

  return response.json();
}
